export function setDateFirms(state, data) {
  // Agregamos los datos de la tabla
  state.tableDateFirms.items = data.data;

  // Quitamos los valores de la tabla del arreglo
  delete data.data;

  // Agregamos los datos de la paginacion
  state.tableDateFirms.pagination = data;
}

export function setErrorForm(state, value) {
  state.errorForm = value;
}

export function setAction(state, value) {
  state.action = value;
}

export function setDateFirm(state, data) {
  data.firm_date_general =  state.dateFirm.firm_date_general;
  state.dateFirm = data;
}

export function resetDateFirm(state, data) {
  state.dateFirm = {
      firm_date_general : state.dateFirm.firm_date_general,
      observations : null,
      firm_date_account : null,
      account : null,
      id : null,
      account_id : null,
      created_at : null,
      deleted_at : null,
  };
}

export function setSubscriberDate(state, data) {
  state.dateFirm.firm_date_general = data.firmDate;
  state.firm_date_modification = data.user_f_d ? `${data.user_f_d.name} ${data.user_f_d.surname} ${data.firm_date_modification_date}`: null;
}

export function setAttributeDateFirm(state, data) {
  state.dateFirm = {
    ...state.dateFirm,
    ...data
  };
}



// WEBPACK FOOTER //
// ./src/modules/dateFirm/mutations.js